import React from "react";
import "./ResponsiveLayout.css";


const ResponsiveDashboardcardlayout = (props) => {
  return (
    <React.Fragment>
      <section className="dashboard-wrapper">
        <div className={`header ResponsiveDashboardcardlayoutHeader d-flex ${props.marginStyle == 'dashboard-summary' && 'ResponsiveDashboardMargin'} `}>
          <img
            className="headerIcon responsiveHeaderIcon"
            src={props.headerIcon}
            alt="dashboard icon"
          />
          <h1 className="headerText mb-0">{props.headerText}</h1>
        </div>
        <div className={`card-layout responsive-card-layout ${props.bgStyle == "assesment" && 'responsiveassesmentbg'}`}>

          <div>{props.children}</div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default ResponsiveDashboardcardlayout;



// WEBPACK FOOTER //
// ./src/new/Components/Layout/ResponsiveLayout.jsx